import {useFontStyles} from "../assets/fontStyles/FontStyles";

function Text(props) {

    const {text, onClick, hover, left, size, weight, color, top} = props

    const styles = {
        marginLeft: left,
        fontSize: size,
        fontWeight: weight,
        color: color,
        top: top
    }

    const classFonts = useFontStyles()

    return (
        <span className={hover ? classFonts.hoverText : classFonts.generalText} onClick={onClick}
              style={styles}>{text}</span>
    )

}

export default Text